import React, { useEffect } from 'react';
import {
  FormControl,
  FormLabel,
  GridItem,
  NumberInput,
  NumberInputField,
  Grid,
} from '@chakra-ui/react';
import CreatableSelect from 'react-select/creatable';
import { useNewKBLeadForm } from '../context/NewKBLeadFormContext';

const NewKBVenueForm = () => {
  // Use the form context for state management
  const { 
    formData, 
    handleFormChange,
    errors
  } = useNewKBLeadForm();

  // Access locations data or initialize if not present
  const locations = formData.locations || { cities: [], venues: [] };
  
  // Log initial values for debugging
  useEffect(() => {
    console.log('[NewKBVenueForm] Initial Venue Form Values:', { 
      locations,
      roomCount: formData.roomCount,
      residenceGuestCount: formData.residenceGuestCount
    });
  }, []);

  // Handle locations changes (both cities and venues)
  const handleLocationsChange = (field, value) => {
    console.log(`[NewKBVenueForm] Updating ${field}:`, value);
    
    // Create a new locations object with the updated field
    const updatedLocations = {
      ...locations,
      [field]: value
    };
    
    // Update the form data with the new locations object
    handleFormChange('locations', updatedLocations);
  };
  
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={6}>
      <GridItem colSpan={2}>
        <FormControl isInvalid={errors?.locations?.cities}>
          <FormLabel>Cities</FormLabel>
          <CreatableSelect
            isMulti
            value={locations.cities?.map(city => ({ label: city, value: city })) || []}
            onChange={(selected) => {
              const cities = selected ? selected.map(option => option.value) : [];
              handleLocationsChange('cities', cities);
            }}
            placeholder="Select or create cities"
          />
        </FormControl>
      </GridItem>

      <GridItem colSpan={2}>
        <FormControl isInvalid={errors?.locations?.venues}>
          <FormLabel>Venues</FormLabel>
          <CreatableSelect
            isMulti
            value={locations.venues?.map(venue => ({ label: venue, value: venue })) || []}
            onChange={(selected) => {
              const venues = selected ? selected.map(option => option.value) : [];
              handleLocationsChange('venues', venues);
            }}
            placeholder="Select or create venues"
          />
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl isInvalid={errors?.roomCount}>
          <FormLabel>Room Count</FormLabel>
          <NumberInput 
            min={0} 
            value={formData.roomCount || 0} 
            onChange={(valueString) => {
              const value = Number(valueString);
              console.log('[NewKBVenueForm] Room Count Changed:', value);
              handleFormChange('roomCount', value);
            }}
          >
            <NumberInputField
              placeholder="Enter room count"
            />
          </NumberInput>
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl isInvalid={errors?.residenceGuestCount}>
          <FormLabel>Residence Guest Count</FormLabel>
          <NumberInput 
            min={0} 
            value={formData.residenceGuestCount || 0} 
            onChange={(valueString) => {
              const value = Number(valueString);
              console.log('[NewKBVenueForm] Residence Guest Count Changed:', value);
              handleFormChange('residenceGuestCount', value);
            }}
          >
            <NumberInputField
              placeholder="Enter residence guest count"
            />
          </NumberInput>
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default NewKBVenueForm;
